<template>
  <modal-wrapper :class="[`bto-sb-modalpopup-${modalSize}`, `${modalPossition}`]"
      v-if="showModal === true" @close="closeModal">
    <div class="bto-sb-modalpopup">
      <div class="bto-sb-modalpopup-title">
        <button type="button" v-on:click.prevent="closeModal()"><i class="bto-app-delete"></i></button>
        <h4>{{messageTitle || t('Mobile.Message')}}</h4>
      </div>
      <div class="bto-sb-modalpopup-content">
        <div v-bind:class="['bto-sb-message', `bto-sb-message-${messageType}`,'bto-sb-fadeindown']">
          <p v-html="messageText"></p>
        </div>
      </div>
      <div class="bto-sb-modalpopup-footer" v-if="buttons.length">
        <button type="submit" class="bto-sb-form-btn" v-for="(button, index) in buttons" :key="index" v-on:click=processButton(button)>
          {{button.label}}
        </button>
      </div>
    </div>
  </modal-wrapper>
</template>

<script>
  import { EventBus } from '../../services/event-bus-service';
  import ModalWrapper from './modal-wrapper';
  import { modalFocus } from '../../services/toastr';

  /**
   * ModalMessageComponent is global component used for displaying messages in a modal
   */
  export default {
    name: 'ModalMessageComponent',
    components: { ModalWrapper },
    data() {
      return {
        showModal: false,
        messageText: '',
        messageType: 'info',
        messageTitle: '',
        /**
         * controls the size of the modal. Posiible values:
         * sm for small
         * md for medium
         * lg for large
         */
        modalSize: 'md',
        /**
         * controls the possition of the modal. Posiible values:
         * start to display the modal at the top
         * end  to display the modal at the bottom
         * '' to display the modal at the middle
         */
        modalPossition: '',
        // array of action buttons {label, event} when clicked will emmit event
        buttons: () => {
          return [];
        },
        /**
         * event to emit when modal closes
         * @type {string | undefined}
         */
        onCloseEvent: null,
      };
    },
    watch: {
      showModal(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
    created() {
      EventBus.$on('modalMessage', (msg) => {
        this.buttons = msg.buttons || [];
        this.messageTitle = msg.title || '';
        if (msg.translate && this.messageTitle) {
          this.messageTitle = this.$translate.text(this.messageTitle);
        }
        this.showModal = msg.showModal;
        this.messageType = msg.messageType || 'info';
        this.messageText = msg.translate ? this.$translate.text(msg.messageText) : msg.messageText;
        this.modalSize = typeof msg.modalSize !== 'undefined' ? msg.modalSize : 'md';
        this.modalPossition = typeof msg.modalPossition !== 'undefined' ? `bto-sb-modalpopup-${msg.modalPossition}` : '';
        this.onCloseEvent = msg.onCloseEvent;
      });
    },
    methods: {
      closeModal() {
        modalFocus();
        this.showModal = false;
        EventBus.$emit('clear-betslip-widget-checker-code');
        if (this.onCloseEvent) {
          EventBus.$emit(this.onCloseEvent);
        }
      },
      processButton(button) {
        EventBus.$emit(button.event, true);
      }
    },
  };
</script>
